/**
 * JSON backup export
 */
import { sanitizeFilename } from '@/utils/escape';
import { saveAs } from 'file-saver';

export function exportJsonBackup(components: any, order: string[], settings: any) {
  const data = {
    version: '3.0',
    exportDate: new Date().toISOString(),
    settings,
    components,
    order,
  };

  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const filename = `${sanitizeFilename(settings.siteName)}-backup.json`;
  saveAs(blob, filename);
  return { success: true, filename };
}
